module.exports = __webpack_public_path__ + "static/media/hoursIcon.a392d2df.svg";